import {
    picture_convert,
    reels_lenghts,
    reels_pos,
    server_config,
    wi,
    behavior_config
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_add_group,
    madnes_add_img,
    madnes_add_sprite, madnes_add_to_group, madnes_set_alpha, madnes_set_angle, madnes_set_img_center,
    madnes_set_pos, madnes_set_pos_x
} from "../framework/src/engine/madnes/madnes_object";
import {cylinder_pos} from "./stars_config";
import {stopposin, stopposin_old} from "./stars_core";
import {madnes_anim_add, madnes_anim_play} from "../framework/src/engine/madnes/madnes_anims";
import {
    bet,
    madnes_fill_range, madnes_get_currtime, madnes_get_json,
    madnes_join, madnes_reverse,
    madnes_set_input_down,
    madnes_set_input_up
} from "../framework/src/engine/madnes/madnes";
import {
    madnes_add_bitmap_text,
    madnes_add_text,
    madnes_format_text, madnes_set_font_size,
    madnes_set_text
} from "../framework/src/engine/madnes/madnes_text";
import {madnes_audio_loop} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_add_to_render, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {stars_mystery_start_rotate, stars_mystery_stop_hand} from "./stars_anims";

// Vytvoreni potrebnych onjektu z nactenych textur.
export function stars_print_desk()
{
    if(typeof behavior_config.reel.spin.motionBlur == "undefined")
    {
        behavior_config.reel.spin.motionBlur = 1;
    }

    if(typeof behavior_config.reel.spin.timeToReachFullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    if(typeof behavior_config.reel.spin.timeToReachNullSpeed == "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
        if(typeof behavior_config.reel.acceleration.spinAccelerationRatio != "undefined")
        {
            behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.acceleration.spinAccelerationRatio;
        }
    }

    //behavior_config.reel.spin.timeToReachNullSpeed = 0;

    if(typeof behavior_config.reel.acceleration.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachFullSpeed = behavior_config.reel.acceleration.moveTime;
    }

    if(typeof behavior_config.reel.brake.moveTime != "undefined")
    {
        behavior_config.reel.spin.timeToReachNullSpeed = behavior_config.reel.brake.moveTime;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed == 0)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.01;
    }

    if(behavior_config.reel.spin.timeToReachFullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachFullSpeed = 0.5;
    }

    if(behavior_config.reel.spin.timeToReachNullSpeed > 0.5)
    {
        behavior_config.reel.spin.timeToReachNullSpeed = 0.5;
    }

    // madnes_set_win_factors(
    //     behavior_config.reel.minBigWinFactor,
    //     behavior_config.reel.minMegaWinFactor,
    //     behavior_config.reel.minSuperMegaWinFactor
    // );

    // stars_set_sounds();

    // if(
    //     typeof server_config.logic != "undefined" &&
    //     typeof server_config.logic.bet_set != "undefined"
    // )
    // {
    //     //bets = server_config.logic.bet_set;
    //     /*var bet0 = [];
    //     for(var b in server_config.logic.bet_set)
    //     {
    //         if(
    //             server_config.logic.bet_set[b] >= 10 &&
    //             server_config.logic.bet_set[b] <= 100
    //         )
    //         {
    //             bet0[bet0.length] = server_config.logic.bet_set[b];
    //         }
    //     }
    //     bets = bet_set = bet0;*/
    // }
    //
    // bets = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

    madnes_add_img("background", "background", 0, 0);
    madnes_add_img("bonus_bg_0", "bonus_bg", cylinder_pos[0] - 160, 71, 0);
    madnes_add_img("bonus_bg_1", "bonus_bg", cylinder_pos[1] - 160, 71, 0);
    madnes_add_img("bonus_bg_2", "bonus_bg", cylinder_pos[2] - 160, 71, 0);


    ////////////////////////////////////////////////////////////////////////////////

    var style = {
        font: "26px Arial",
        fontWeight: "bold",
        fill: "#dd00cc",
        align: "left",
        boundsAlignH: "left",
        boundsAlignV: "top",
        wordWrap: false,
        wordWrapWidth: 300
    };

    // Nastaveni / vytvoreni pasu pro valce podle navratu ze serveru
    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_add_sprite("reels_bufer_" + i + "_" + j, picture_convert[server_config.logic.reels[i][j]] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "blur", [0]);
            madnes_anim_add("reels_bufer_" + i + "_" + j, "stop", [1]);

            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");

            //madnes_add_text("text_reels_bufer_" + i + "_" + j, cylinder_pos[i], -999, "reels_bufer_" + i + "_" + j, style);
            //madnes_set_img_center("text_reels_bufer_" + i + "_" + j, 0, -2.5);

            reels_lenghts[i] = j * 1 + 1;

            stopposin[i] = reels_lenghts[i];
            stopposin_old[i] = reels_lenghts[i];
        }

        // S0-S2 = priprava vyherni pozice na kazdem valci
        madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.logic.failResult[i][2]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.logic.failResult[i][1]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.logic.failResult[i][0]] + "_blur", cylinder_pos[i], 10, 1, 0.5, 0.5);

        //madnes_add_sprite("reels_bufer_" + i + "_S0", picture_convert[server_config.logic.failResult[i][2]], cylinder_pos[i], 10, 1, 0.5, 0.5);
        //madnes_add_sprite("reels_bufer_" + i + "_S1", picture_convert[server_config.logic.failResult[i][1]], cylinder_pos[i], 10, 1, 0.5, 0.5);
        //madnes_add_sprite("reels_bufer_" + i + "_S2", picture_convert[server_config.logic.failResult[i][0]], cylinder_pos[i], 10, 1, 0.5, 0.5);
        /*
        for(var anim in icons[picture_convert[server_config.logic.failResult[i][2]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S0", anim, icons[picture_convert[server_config.logic.failResult[i][2]]][anim]);
        }
        for(var anim in icons[picture_convert[server_config.logic.failResult[i][1]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S1", anim, icons[picture_convert[server_config.logic.failResult[i][1]]][anim]);
        }
        for(var anim in icons[picture_convert[server_config.logic.failResult[i][0]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S2", anim, icons[picture_convert[server_config.logic.failResult[i][0]]][anim]);
        }
        */
        madnes_add_sprite("reels_bufer_" + i + "_TMP0", picture_convert[0] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP1", picture_convert[0] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP2", picture_convert[0] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);

        madnes_add_sprite("reels_bufer_" + i + "_TMP20", picture_convert[0] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP21", picture_convert[0] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);
        madnes_add_sprite("reels_bufer_" + i + "_TMP22", picture_convert[0] + "_blur", cylinder_pos[i], -9999, 1, 0.5, 0.5);


        /*
        madnes_add_text("text_reels_bufer_" + i + "_S0", cylinder_pos[i], -999, "reels_bufer_" + i + "_S0", style);
        madnes_add_text("text_reels_bufer_" + i + "_S1", cylinder_pos[i], -999, "reels_bufer_" + i + "_S1", style);
        madnes_add_text("text_reels_bufer_" + i + "_S2", cylinder_pos[i], -999, "reels_bufer_" + i + "_S2", style);

        madnes_set_img_center("text_reels_bufer_" + i + "_S0", 0, -2.5);
        madnes_set_img_center("text_reels_bufer_" + i + "_S1", 0, -2.5);
        madnes_set_img_center("text_reels_bufer_" + i + "_S2", 0, -2.5);
        */

        madnes_anim_add("reels_bufer_" + i + "_S0", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S0", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S1", "blur", [0]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "stop", [1]);
        madnes_anim_add("reels_bufer_" + i + "_S2", "blur", [0]);

        /*
        for(var anim in icons[picture_convert[server_config.logic.failResult[i][0]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S0", anim, icons[picture_convert[server_config.logic.failResult[i][0]]][anim]);
        }

        for(var anim in icons[picture_convert[server_config.logic.failResult[i][1]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S1", anim, icons[picture_convert[server_config.logic.failResult[i][1]]][anim]);
        }

        for(var anim in icons[picture_convert[server_config.logic.failResult[i][2]]])
        {
            madnes_anim_add("reels_bufer_" + i + "_S2", anim, icons[picture_convert[server_config.logic.failResult[i][2]]][anim]);
        }
        */
        madnes_anim_play("reels_bufer_" + i + "_S0", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S1", "stop");
        madnes_anim_play("reels_bufer_" + i + "_S2", "stop");

        reels_pos[i] = 0;
    }

    /*
    for(var i = 0; i < 54; i++)
    {
        madnes_add_sprite("reels_bufer_wild_" + i, picture_convert[1], 10, 10, 0, 0.5, 0.5);
    }
    */

    madnes_add_img("bckground2", "reels_cover", 0, 0);

    madnes_add_img("logo_reels", "logo_reels", wi / 2, -2, 1, 0.5, 0);

    // S
    madnes_add_img("logo_reels_shine_0", "logo_reels_shine", wi / 2 - 126, 46, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_1", "logo_reels_shine", wi / 2 - 118, 24, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_2", "logo_reels_shine", wi / 2 - 104, 38, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_3", "logo_reels_shine", wi / 2 - 98,  24, 0, 0.5, 0.5);


    // T
    madnes_add_img("logo_reels_shine_4", "logo_reels_shine", wi / 2 - 86, 18, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_5", "logo_reels_shine", wi / 2 - 76, 44, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_6", "logo_reels_shine", wi / 2 - 72, 32, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_7", "logo_reels_shine", wi / 2 - 56, 24, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_8", "logo_reels_shine", wi / 2 - 56, 42, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_9", "logo_reels_shine", wi / 2 - 44, 24, 0, 0.5, 0.5);

    // A
    madnes_add_img("logo_reels_shine_10", "logo_reels_shine", wi / 2 - 34, 44, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_11", "logo_reels_shine", wi / 2 - 22, 34, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_12", "logo_reels_shine", wi / 2 - 10, 18, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_13", "logo_reels_shine", wi / 2 + 12, 26, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_14", "logo_reels_shine", wi / 2 + 22, 42, 0, 0.5, 0.5);

    // R
    madnes_add_img("logo_reels_shine_15", "logo_reels_shine", wi / 2 + 40, 28, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_16", "logo_reels_shine", wi / 2 + 52, 24, 0, 0.5, 0.5);

    madnes_add_img("logo_reels_shine_17", "logo_reels_shine", wi / 2 + 66, 26, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_18", "logo_reels_shine", wi / 2 + 74, 44, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_19", "logo_reels_shine", wi / 2 + 78, 26, 0, 0.5, 0.5);

    // S
    madnes_add_img("logo_reels_shine_20", "logo_reels_shine", wi / 2 + 94,  38, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_21", "logo_reels_shine", wi / 2 + 96,  24, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_22", "logo_reels_shine", wi / 2 + 106, 42, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_23", "logo_reels_shine", wi / 2 + 114, 28, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_24", "logo_reels_shine", wi / 2 + 122, 40, 0, 0.5, 0.5);
    madnes_add_img("logo_reels_shine_25", "logo_reels_shine", wi / 2 + 126, 18, 0, 0.5, 0.5);


    madnes_add_sprite("reels_bufer_myst_0", picture_convert[10], 0, 0, 0, 0.5, 0.5);
    madnes_add_sprite("reels_bufer_myst_1", picture_convert[10], 0, 0, 0, 0.5, 0.5);
    madnes_add_sprite("reels_bufer_myst_2", picture_convert[10], 0, 0, 0, 0.5, 0.5);

    madnes_add_img("bonus_background", "bonus_background", -9999, -9999);

    madnes_add_group("mystery_wheel");
    madnes_set_pos("mystery_wheel", -9999, -9999);
    madnes_add_img("mystery_wheel0", "mystery_wheel", 0, 0, 1, 0.5, 0.5);
    madnes_add_to_group("mystery_wheel", "mystery_wheel0")


    //madnes_set_input_down("mystery_wheel", stars_mystery_stop_hand);
    //madnes_set_input_up("mystery_wheel", stars_mystery_start_rotate)

    madnes_set_input_down("bonus_background", stars_mystery_stop_hand);
    madnes_set_input_up("bonus_background", stars_mystery_start_rotate)

    madnes_add_img("mystery_wheel_center", "mystery_wheel_center", -9999, -9999, 1, 0.5, 0.5);

    madnes_add_img("mystery_arrow_left", "mystery_arrow_left", -9999, -9999, 1, 1.46, 1.9);
    madnes_add_img("mystery_arrow_right", "mystery_arrow_right", -9999, -9999, 1, -0.46, 1.9);

    madnes_add_sprite("mystery_win_rect", "Mystery_Win", -9999, -9999);

    madnes_add_img("mystery_arrow_center", "mystery_arrow_center", -9999, -9999, 1, 0.5, 6.5);

    madnes_add_img("mystery_hand", "mystery_hand", -9999, -9999, 1, 0.5, 4);

    madnes_add_sprite('wing_l', 'wing_left', -9999, -9999, 1);
    madnes_add_sprite('wing_r', 'wing_right', -9999, -9999, 1);

    madnes_anim_add("wing_l", "anim", madnes_join( madnes_fill_range(0, 16), madnes_reverse( madnes_fill_range(0, 16) ) ) );
    madnes_anim_add("wing_r", "anim", madnes_join( madnes_fill_range(0, 16), madnes_reverse( madnes_fill_range(0, 16) ) ) );

    madnes_add_sprite('mystery_symbol', 'mystery_symbol', -9999, -9999, 1);

    madnes_add_sprite("table_bonus_win", "table_bonus_win", -9999, -9999);

    madnes_add_bitmap_text("mystery_sprite_text", "big-win",-9999, -9999, "0", 80);
    madnes_set_img_center("mystery_sprite_text", 0.5, 0.5)
    madnes_set_alpha("mystery_sprite_text", 0);


    madnes_add_sprite("bw_bg", "bw_bg", -9999, -9999, 0, 0.5, 0.5);

    madnes_add_sprite("bw_shine1", "bw_shine", -9999, -9999, 0, 0.5, 0.5);
    madnes_add_sprite("bw_shine2", "bw_shine", -9999, -9999, 0, 0.5, 0.5);

    madnes_add_sprite("bw_table", "bw_table", -9999, -9999, 0, 0.5, 0.5);

    madnes_add_sprite("bw_big", "bw_big", -9999, -9999, 0, 0.5, 0.5);
    madnes_add_sprite("bw_mega", "bw_mega", -9999, -9999, 0, 0.5, 0.5);
    madnes_add_sprite("bw_super", "bw_super", -9999, -9999, 0, 0.5, 0.5);

    madnes_add_bitmap_text("bw_text", "big-win", -9999, -9999, "0", 60);
    madnes_set_img_center("bw_text", 0.5, 0.5);

    madnes_add_sprite("bw_stroke", "bw_stroke", -9999, -9999, 0, 0.5, 0.5);

    madnes_audio_loop("background");

    setTimeout(stars_anim_logo, 2000);
}


var stars_anim_logo_starttime = 0;
function stars_anim_logo()
{
    stars_anim_logo_starttime = madnes_get_currtime();
    madnes_add_to_render(stars_anim_logo_render);
}

function stars_anim_logo_render()
{
    var difftime = madnes_get_currtime() - stars_anim_logo_starttime;
    var maxtime = 3600;
    var len = 26;
    var max_a = 1;

    if(maxtime < difftime)
    {
        for(var i = 0; i < len; i++)
        {
            madnes_set_alpha("logo_reels_shine_" + i, 0);
            madnes_set_angle("logo_reels_shine_" + i, -20);
        }

        madnes_rem_from_render(stars_anim_logo_render);

        setTimeout(stars_anim_logo, Math.random() * 30000);

    }
    else
    {
        var pos = difftime / maxtime * 100;
        for(var i = 0; i < 26; i++)
        {
            var x2 = 0;
            var a = ( pos - ( i * 3 ) ) / 16;

            if(a > max_a * 2)
            {
                a = 0;
            }
            else if(a > max_a)
            {
                a = ( max_a * 2 ) - a;
                x2 = 1;
            }

            if(a > 1)
            {
                a = 1;
            }

            if(a < 0)
            {
                a = 0;
            }

            var ang = a * 10;
            if(x2 == 1)
            {
                ang = (  max_a + ( max_a - a ) ) * 10;
            }

            madnes_set_alpha("logo_reels_shine_" + i, a);
            madnes_set_angle("logo_reels_shine_" + i, ang);
        }
    }
}


var settings_background_pos;
export function stars_infomenu_init()
{
    settings_background_pos = 1;
    madnes_add_img("settings_background_1", "settings_background_1", -9999, -9999);
    madnes_add_img("settings_background_2", "settings_background_2", -9999, -9999);
    madnes_add_img("settings_background_3", "settings_background_3", -9999, -9999);


    madnes_add_group("settings_group_1");
    madnes_add_group("settings_group_2");
    madnes_add_group("settings_group_3");

    madnes_add_bitmap_text("mel", "wintable", 210, 240, "0", 80);
    madnes_add_bitmap_text("sev", "wintable", 588, 240, "0", 80);
    madnes_add_bitmap_text("gra", "wintable", 964, 240, "0", 80);

    madnes_add_bitmap_text("bel", "wintable", 200, 436, "0", 80);
    madnes_add_bitmap_text("che", "wintable", 780, 436, "0", 80);


    madnes_set_img_center("mel", 0.5, 0.5);
    madnes_set_img_center("sev", 0.5, 0.5);
    madnes_set_img_center("gra", 0.5, 0.5);
    madnes_set_img_center("bel", 0.5, 0.5);
    madnes_set_img_center("che", 0.5, 0.5);

    madnes_add_to_group("settings_group_1", "mel");
    madnes_add_to_group("settings_group_1", "sev");
    madnes_add_to_group("settings_group_1", "gra");
    madnes_add_to_group("settings_group_1", "bel");
    madnes_add_to_group("settings_group_1", "che");


    madnes_add_bitmap_text("mystery", "wintable", 740, 214, "0", 80);
    madnes_add_to_group("settings_group_2", "mystery");
    madnes_set_img_center("mystery", 0, 0.5);


    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);

    var infotext = madnes_get_json("infotext");

    for(var i in infotext)
    {
        var x = infotext[i].position[0];
        var y = infotext[i].position[1];
        var page = infotext[i].page;
        var lineHeight0 = infotext[i].lineHeight;
        var lineHeight1 = infotext[i].lineHeight;
        var x_add = 0;
        var center = 0;

        if(infotext[i].center && infotext[i].center == 1)
        {
            center = 1;
        }

        var style0 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };
        var style1 = {
            "font": "32px Arial",
            "fill": "#ffffff",
            "fontWeight": "",
        };

        if(infotext[i].fontSize && infotext[i].font)
        {
            style0.font = infotext[i].fontSize + "px " + infotext[i].font;
            style1.font = infotext[i].fontSize + "px " + infotext[i].font;
        }
        if(infotext[i].color)
        {
            style0.fill = infotext[i].color;
            style1.fill = infotext[i].color;
        }
        if(infotext[i].bold)
        {
            if(infotext[i].bold == 1)
            {
                style0.fontWeight = "bold";
                style1.fontWeight = "bold";
            }
            else if(infotext[i].bold == 1)
            {
                style0.fontWeight = "";
                style1.fontWeight = "";
            }
        }

        if(infotext[i].title.fontSize && infotext[i].title.font)
        {
            style0.font = infotext[i].title.fontSize + "px " + infotext[i].title.font;
        }
        if(infotext[i].title.lineHeight)
        {
            lineHeight0 = infotext[i].title.lineHeight;
        }
        if(infotext[i].title.color)
        {
            style0.fill = infotext[i].title.color;
        }
        if(infotext[i].title.bold)
        {
            if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "bold";
            }
            else if(infotext[i].title.bold == 1)
            {
                style0.fontWeight = "";
            }
        }

        if(infotext[i].body.fontSize && infotext[i].body.font)
        {
            style1.font = infotext[i].body.fontSize + "px " + infotext[i].body.font;
        }
        if(infotext[i].body.color)
        {
            style1.fill = infotext[i].body.color;
        }
        if(infotext[i].body.lineHeight)
        {
            lineHeight1 = infotext[i].body.lineHeight;
        }
        if(infotext[i].body.bold)
        {
            if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "bold";
            }
            else if(infotext[i].body.bold == 1)
            {
                style1.fontWeight = "";
            }
        }
        if(infotext[i].body.x_add)
        {
            x_add = infotext[i].body.x_add;
        }

        var line0 = 0;
        var line1 = 0;

        for(var j in infotext[i].title.content)
        {
            var text = infotext[i].title.content[j].toUpperCase();
            madnes_add_text("info_header_" + i + "_"  + j + "_" + line0, x, y + line0 * lineHeight0, text, style0);
            if(center == 1)
            {
                madnes_set_img_center("info_header_" + i + "_"  + j + "_" + line0, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_header_" + i + "_"  + j + "_" + line0);
            line0++;
        }

        for(var j in infotext[i].body.content)
        {
            var text = infotext[i].body.content[j];
            madnes_add_text("info_body_" + i + "_"  + j + "_" + line1, x * 1 + x_add, y + line0 * lineHeight0 + line1 * lineHeight1, text, style1);
            if(center == 1)
            {
                madnes_set_img_center("info_body_" + i + "_"  + j + "_" + line1, 0.5, 0);
            }
            madnes_add_to_group("settings_group_" + ( page * 1 + 1 ), "info_body_" + i + "_"  + j + "_" + line1);
            line1++;
        }

    }

    stars_infomenu_update();
}

export var openinfo = false;

export function stars_infomenu_open()
{
    settings_background_pos = 1;

    madnes_set_pos("settings_background_1", 0, 0);
    madnes_set_pos("settings_background_2", 2500, 0);
    madnes_set_pos("settings_background_3", 2500, 0);


    madnes_set_pos("settings_group_1", 0, 0);
    madnes_set_pos("settings_group_2", 2500, 0);
    madnes_set_pos("settings_group_3", 2500, 0);

    openinfo = true;
}

export function stars_infomenu_close()
{
    madnes_set_pos("settings_background_1", -9999, -9999);
    madnes_set_pos("settings_background_2", -9999, -9999);
    madnes_set_pos("settings_background_3", -9999, -9999);


    madnes_set_pos("settings_group_1", -9999, -9999);
    madnes_set_pos("settings_group_2", -9999, -9999);
    madnes_set_pos("settings_group_3", -9999, -9999);

    openinfo = false;
}

export function stars_infomenu_update()
{
    madnes_set_text("mel", server_config.logic.symbols[1].factors[2] * bet);
    madnes_set_text("sev", server_config.logic.symbols[0].factors[2] * bet);
    madnes_set_text("gra", server_config.logic.symbols[2].factors[2] * bet);
    madnes_set_text("bel", server_config.logic.symbols[3].factors[2] * bet);
    madnes_set_text("che", server_config.logic.symbols[6].factors[2] * bet);

    madnes_set_text("mystery", madnes_format_text( server_config.logic.symbols[10].factors[1] * bet ) + " - " + madnes_format_text( server_config.logic.symbols[10].factors[2] * bet ) );

    if(bet > 100)
    {
        madnes_set_font_size("mel", 60)
        madnes_set_font_size("sev", 60)
        madnes_set_font_size("gra", 60)
        madnes_set_font_size("bel", 60)
        madnes_set_font_size("che", 60)
        madnes_set_font_size("mystery", 60)
    }
    else
    {
        madnes_set_font_size("mel", 80)
        madnes_set_font_size("sev", 80)
        madnes_set_font_size("gra", 80)
        madnes_set_font_size("bel", 80)
        madnes_set_font_size("che", 80)
        madnes_set_font_size("mystery", 80)
    }

}

var move_start = 0;
var move_total = 250;
export function stars_infomenu_left()
{
    if(!openinfo) return;

    if(stars_infomenu_move_in == 0)
    {
        stars_infomenu_move_in = 1;
        stars_infomenu_move_dir = 1;
        move_start = madnes_get_currtime();
        madnes_add_to_render(stars_infomenu_move);
    }
}

export function stars_infomenu_right()
{
    if(!openinfo) return;

    if(stars_infomenu_move_in == 0)
    {
        stars_infomenu_move_in = 1;
        stars_infomenu_move_dir = -1;
        move_start = madnes_get_currtime();
        madnes_add_to_render(stars_infomenu_move);
    }
}

var stars_infomenu_move_in = 0;
var stars_infomenu_move_dir = 0;
function stars_infomenu_move()
{
    var difftime = madnes_get_currtime() - move_start;
    var end = 0;
    if(difftime > move_total)
    {
        difftime = move_total;
        end = 1;
    }

    var settings_background_pos2;
    settings_background_pos2 = settings_background_pos * 1 + ( stars_infomenu_move_dir * -1);
    if(settings_background_pos2 > 3)
    {
        settings_background_pos2 = 1;
    }
    if(settings_background_pos2 < 1)
    {
        settings_background_pos2 = 3;
    }

    var pos1 = wi * ( ( ( 100 / move_total ) * difftime ) / 100 ) * stars_infomenu_move_dir;
    if(stars_infomenu_move_dir < 0)
    {
        var pos2 = pos1 + wi;
    }
    else
    {
        var pos2 = wi * -1 + pos1;
    }

    madnes_set_pos_x("settings_background_" + settings_background_pos, pos1, 0);
    madnes_set_pos_x("settings_background_" + settings_background_pos2, pos2, 0);

    madnes_set_pos_x("settings_group_" + settings_background_pos, pos1, 0);
    madnes_set_pos_x("settings_group_" + settings_background_pos2, pos2, 0);

    if(end == 1)
    {
        madnes_rem_from_render(stars_infomenu_move);

        madnes_set_pos_x("settings_background_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_background_" + settings_background_pos, 2500, 0);

        madnes_set_pos_x("settings_group_" + settings_background_pos2, 0, 0);
        madnes_set_pos_x("settings_group_" + settings_background_pos, 2500, 0);

        settings_background_pos = settings_background_pos2;
        stars_infomenu_move_in = 0;
    }
}


